


































import Vue from "vue";
import biliShare from "@bilibili/share-h5-next";
import "@bilibili/share-h5-next/dist/share-h5.css";
import Calender from "@/components/Calender.vue";
import CheerButton from "@/components/CheerButton.vue";
import { ActivityStatus } from "@/consts";
import { isAndroid, isiOS, isQQ, openLink, isIpad, toast, report } from "@bilibili/growup-utils";
import { openApp } from "@bilibili/h5-utils";
import { getTargetURLByENV, inBiliApp } from "@/utils/detect";
import { closeWebview } from "@/utils/jsb-helpers";
import { getInfo } from "@/services/request/home";
import { parseParamToObj } from "@/utils/url";

const options = {
  title: "来B站和我一起玩转51，集卡瓜分百万现金",
  desc: "还能获取好友专属干杯合影哦",
  link: window.location.href, // 必传，请传一个可以访问的url
  pics: "https://activity.hdslb.com/blackboard/static/20210427/dfa9f6c9df5080266c0de97428ac977b/b8Ekj4CVAt.png"
};

// const COPY_TEXT =
//   "2 gHA123456b 你的好友邀请你一起干杯集卡，瓜分百万现金大奖，复制链接并打开哔哩哔哩 【 https://m.bilibili.com/ 】";

export default Vue.extend({
  name: "ExHome",
  components: {
    Calender,
    CheerButton
  },
  data: () => ({
    cheerNum: 0,
    status: ActivityStatus.COLLECTING as ActivityStatus
  }),
  mounted() {
    if (!inBiliApp && !isiOS && !isAndroid && !isIpad) {
      this.$dialog.show("pc-dialog");
      return;
    }
    biliShare.setContent(options);
  },
  created() {
    const { fromchannel } = parseParamToObj(window.location) as any;
    if (fromchannel) {
      report("fromchannel", { fromchannel });
    }
    if (inBiliApp) {
      const pageId = "/redpack/activity-PBnicOEeUP.html";
      const u =
        getTargetURLByENV(pageId) + "?navhide=1" + (fromchannel !== undefined ? `&fromchannel=${fromchannel}` : "");
      // 跳转端内页面
      window.location.replace(u);
      return;
    }
    this.getInfo();
  },
  computed: {
    message(): string {
      return "集齐五种主题卡瓜分百万现金";
    },
    isActive(): boolean {
      return this.status === ActivityStatus.COLLECTING || this.status === ActivityStatus.NOT_START;
    },
    isAward(): boolean {
      return this.status === ActivityStatus.RESULT || this.status === ActivityStatus.AWARD;
    },
    isEnd(): boolean {
      return this.status === ActivityStatus.END;
    }
  },
  methods: {
    goToRules() {
      report("go-to-rule");
      const pageId = "/redpack/activity-zEigj73Mwp.html";
      openLink(getTargetURLByENV(pageId));
    },
    getInfo() {
      getInfo().then((res) => {
        if (res.code === 160001) {
          this.status = ActivityStatus.NOT_START;
          return;
        }
        if (res.code === 0) {
          const { activity_status, cheers_num } = res.data;
          if (activity_status === 4) {
            this.status = 5;
          } else {
            this.status = activity_status;
          }

          this.cheerNum = cheers_num;
        }
      });
    },
    closeWindow() {
      closeWebview();
    },
    goToApp() {
      report("click_call_app");
      if (this.status === ActivityStatus.NOT_START) {
        toast("活动尚未开始");
        return;
      }
      if (this.status === ActivityStatus.END) {
        toast("很遗憾活动已结束哦");
        return;
      }
      this.triggerDownload();
    },
    triggerDownload() {
      try {
        const { fromchannel } = parseParamToObj(window.location) as any;
        const pageId = "/redpack/activity-PBnicOEeUP.html";
        const u =
          getTargetURLByENV(pageId) + "?navhide=1" + (fromchannel !== undefined ? `&fromchannel=${fromchannel}` : "");
        const schema = `bilibili://browser?url=${encodeURIComponent(u)}`;

        if (isiOS) {
          openApp({
            schema,
            universalLink: u,
            delayDownload: true
          });
        } else {
          if (isQQ && isAndroid) {
            openApp({
              downloadUrl: "https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_growthact1.apk"
            });
          } else {
            // openApp({ schema: 'bilibili://rank', delayDownload: true });
            openApp({
              schema,
              universalLink: u,
              delayDownload: true
            });
          }
        }
      } catch {
        openApp({});
      }
    }
  }
});
